/* eslint-disable import/no-cycle */
import Util from './Util';
import {getViewingAs, getLocale} from './ApiConfig';

export const userInfo = {};

function initDDC(accountId, userId, internal, isNP) {
    return {
        account: {accountId},
        isInternal: Boolean(internal),
        appKey: 'promotions',
        currentLocale: getLocale()?.replace('-', '_'),
        coreUrl: `https://cc-static${isNP ? '-qa' : ''}.ddcplatform${
            isNP ? '-np' : ''
        }.dealer.com/cc7/configuration/3.9.2/core/`,
        commonContainer: {
            entryResource: `/commoncontainer/${internal ? `as/${accountId}/${userId}/` : ''}`
        }
    };
}

export function parseUserInfoFromEndpoint(info, isNP) {
    const {accountId, userId, first, last, internalUserId, userPermissions} = info;
    const isInternal = internalUserId && internalUserId.trim() !== '';
    const ddc = initDDC(accountId, userId, isInternal, isNP);
    if (isInternal) {
        ddc.actualUser = {
            userId: internalUserId,
            internalUserId,
            firstName: first,
            lastName: last
        };
        ddc.viewingOrActualUser = {
            userId,
            firstName: first,
            lastName: last
        };
    } else {
        ddc.actualUser = {
            userId,
            firstName: first,
            lastName: last
        };
        ddc.viewingOrActualUser = {...ddc.actualUser};
    }
    if (userPermissions) {
        ddc.permissions = userPermissions;
    }
    return ddc;
}

export function hasAccess(userInfo_) {
    let userinfo = userInfo;
    if (userInfo_ !== undefined) {
        userinfo = userInfo_;
    }
    if (Object.keys(userinfo).length === 0) {
        return true;
    }
    if (!userinfo.ddc) {
        return true;
    }
    if (!userinfo.ddc?.permissions) {
        return true;
    }
    if (userinfo.ddc.permissions?.length === 0) {
        return false;
    }
    if (!userinfo.ddc.permissions?.includes('MEDIALIBRARY')) {
        return false;
    }
    return true;
}

export default async function setupUserInfo() {
    let userInfoPath = '/landing/nxlambda/controlcenter';
    const viewingAs = getViewingAs();
    if (viewingAs && viewingAs.length === 3) {
        userInfoPath += `?asAccount=${encodeURIComponent(viewingAs[1])}&asUser=${encodeURIComponent(viewingAs[2])}`;
    }
    const userInfoResponse = await fetch(userInfoPath, {referrer: ''});
    if (userInfoResponse.ok) {
        const uinfo = await userInfoResponse.json();
        const info = parseUserInfoFromEndpoint(uinfo, Util.isNonProd());
        userInfo.ddc = {...info};
    } else if ((userInfoResponse.status === 403 || userInfoResponse.status === 401) && !Util.isWidget()) {
        Util.loggedOutCheck();
    }
}
